import { parseApiError } from './apiError';
const base = () => `${process.env.REACT_APP_API_URL}api/tickets`;

const authHeaders = (token: string) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export const getAllTickets = async (token: string) => {
  const res = await fetch(base(), { headers: authHeaders(token) });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};

export const createTicket = async (
  data: { user_id: string; rental_id?: string; subject: string; description: string; category?: string; priority?: string },
  token: string
) => {
  const res = await fetch(base(), {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(data)
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};

export const updateTicket = async (
  id: string,
  data: { status?: string; priority?: string; admin_response?: string },
  token: string
) => {
  const res = await fetch(`${base()}/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(data)
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};
